import {
    FILE_UPLOAD_PAGE_LOADED,
    FILE_UPLOAD_PAGE_UNLOADED,
    FILE_LIST_PAGE_LOADED,
    FILE_LIST_PAGE_UNLOADED,
    FILE_UPLOAD,
    FILE_DETAIL_PAGE_LOADED,
    FILE_DETAIL_PAGE_UNLOADED,
    FILE_DELETE,
    FILE_DOWNLOAD,
    ASYNC_START,
    DIRECTORY_LIST_PAGE_LOADED,
    DIRECTORY_LIST_PAGE_UNLOADED,
    DIRECTORY_ADD_PAGE_LOADED,
    DIRECTORY_ADD_PAGE_UNLOADED,
    DIRECTORY_ADD,
    DIRECTORY_UPDATE_PAGE_LOADED,
    DIRECTORY_UPDATE_PAGE_UNLOADED,
    DIRECTORY_UPDATE,
    DIRECTORY_REMOVE,
    LOG_LIST_PAGE_LOADED,
    LOG_LIST_PAGE_UNLOADED,
    GROUP_LIST_PAGE_LOADED,
    GROUP_LIST_PAGE_UNLOADED,
    GROUP_ADD,
    GROUP_DETAIL_PAGE_LOADED,
    GROUP_DETAIL_PAGE_UNLOADED,
    GROUP_UPDATE,
    GROUP_REMOVE,
    GROUP_ASSIGN_USER,
    GROUP_REMOVE_USER,
    FILE_PERMISSIONS_UPDATE
} from '../constants/actionTypes';
import { REACT_APP_PAGESIZE } from '../constants/config'

export default (state = {}, action) => {
    switch (action.type) {
        case FILE_LIST_PAGE_LOADED:
            return {
                ...state,
                files: action.error ? null : (action.payload.files || []),
                directory: action.error ? null : action.payload.directory,
                sub_directories: action.error ? null : (action.payload.sub_directories || [])
            };
        case DIRECTORY_LIST_PAGE_LOADED:
            return {
                ...state,
                directories: action.error ? null : action.payload,
            };
        case FILE_DETAIL_PAGE_LOADED:
            return {
                ...state,
                file: action.error ? null : action.payload[0],
                logs: action.error ? null : action.payload[1].logs,
                totalCount: action.error ? 0 : action.payload[1].totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil((action.error ? 0 : action.payload[1].totalCount || 0) / REACT_APP_PAGESIZE),
                groups: action.error ? null : action.payload[2],
            }
        case FILE_PERMISSIONS_UPDATE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                file: action.error ? state.file : action.payload,
            }
        case FILE_UPLOAD_PAGE_LOADED:
            return {
                ...state,
                directory: action.error ? null : action.payload[0],
                groups: action.error ? null : action.payload[1],
            }
        case DIRECTORY_ADD_PAGE_LOADED:
            return {
                ...state,
                directory: action.error ? null : action.payload,
            }
        case DIRECTORY_UPDATE_PAGE_LOADED:
            return {
                ...state,
                directory: action.error ? null : action.payload[0],
                logs: action.error ? null : action.payload[1].logs,
                totalCount: action.payload[1].totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil((action.payload[1].totalCount || 0) / REACT_APP_PAGESIZE)
            }
        case LOG_LIST_PAGE_LOADED:
            return {
                ...state,
                logs: action.error ? null : action.payload.logs,
                totalCount: action.error ? 0 : action.payload.totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil((action.error ? 0 : action.payload.totalCount) / REACT_APP_PAGESIZE)
            }
        case GROUP_LIST_PAGE_LOADED:
            return {
                ...state,
                groups: action.error ? null : action.payload,
            }
        case GROUP_DETAIL_PAGE_LOADED:
            return {
                ...state,
                group: action.error ? null : action.payload,
            }
        case FILE_UPLOAD_PAGE_UNLOADED:
        case FILE_LIST_PAGE_UNLOADED:
        case FILE_DETAIL_PAGE_UNLOADED:
        case DIRECTORY_LIST_PAGE_UNLOADED:
        case DIRECTORY_ADD_PAGE_UNLOADED:
        case DIRECTORY_UPDATE_PAGE_UNLOADED:
        case LOG_LIST_PAGE_UNLOADED:
        case GROUP_LIST_PAGE_UNLOADED:
        case GROUP_DETAIL_PAGE_UNLOADED:
            return {};
        case FILE_UPLOAD:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case FILE_DELETE:
            const id = action.key
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                // files: state.files ? state.files.filter(item => item.key !== id) : [],
            };
        case FILE_DOWNLOAD:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                // files: state.files ? state.files.filter(item => item.key !== id) : [],
            };
        case DIRECTORY_ADD:
        case DIRECTORY_UPDATE:
        case DIRECTORY_REMOVE:
        case GROUP_ADD:
        case GROUP_REMOVE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case GROUP_UPDATE:
        case GROUP_ASSIGN_USER:
        case GROUP_REMOVE_USER:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                group: action.error ? state.group : action.payload,
            };
        case ASYNC_START:
            return {
                ...state,
            }
        default:
            return state;
    }
};
